(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["s-sec-card-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initSliders() {
    document.querySelectorAll('.s-sec-card-slider').forEach(function (section) {
      var track = section.querySelector('.s-sec-card-slider__track--slider');
      if (!track) return;

      var dots  = section.querySelectorAll('.s-sec-card-slider__hint-dot');
      var cards = track.querySelectorAll('.s-sec-card-slider__card');
      if (!dots.length || !cards.length) return;

      var tickId = null;

      function getActiveIndex() {
        var trackRect = track.getBoundingClientRect();
        var cx = trackRect.left + trackRect.width / 2;
        var closest = 0;
        var closestDist = Infinity;
        cards.forEach(function (card, i) {
          var r = card.getBoundingClientRect();
          var dist = Math.abs(r.left + r.width / 2 - cx);
          if (dist < closestDist) { closestDist = dist; closest = i; }
        });
        return closest;
      }

      function updateDots(active) {
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === active);
        });
      }

      track.addEventListener('scroll', function () {
        if (tickId) return;
        tickId = requestAnimationFrame(function () {
          tickId = null;
          updateDots(getActiveIndex());
        });
      }, { passive: true });

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          if (cards[i]) {
            cards[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
        });
      });

      updateDots(0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSliders);
  } else {
    initSliders();
  }

  document.addEventListener('shopify:section:load', initSliders);
})();

  } catch(e) { console.error(e); }
})();
})();
